export const myBooking = (req) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json',
      'access_token': req?.access_token,
      'site_id': req?.site_id
     },
    body: JSON.stringify(req)
  };
  // console.log('POST', requestOptions)
  return fetch('/shared/api/myBooking', requestOptions).then((response) => response.json())
}

export const getCancellation = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(query)
  };
  return fetch('/shared/api/getcancellation', requestOptions).then((response) => response.json())
}
export const getCancel = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(query),
  }
  return fetch('/shared/api/getcancel', requestOptions).then((response) => response.json())
}
export const getCancellationFlight = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(query)
  };
  return fetch('/shared/api/getcancellationflight', requestOptions).then((response) => response.json())
}

export const bookingStatus = (query) => {
  let request = {
    reference_id: query.bookingref,
    service: query.service,
  }
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  }
  return fetch('/shared/api/bookingstatus', requestOptions).then((response) => response.json())
}

export const initHold = (query) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(query),
  }
  return fetch('/shared/api/initHold', requestOptions).then((response) => response.json())
}

export const traccsReport = (req) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req)
  };
  return fetch('/shared/api/leggerTraccsReport', requestOptions).then((response) => response.json())
}

export const myActivityBooking = (req) => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req)
  };
  // console.log('POST', requestOptions)
  return fetch('/shared/api/myActivityBooking', requestOptions).then((response) => response.json())
}
